import { createBrowserRouter } from 'react-router-dom';

import { AdminLayout } from '@/components/AdminLayout';
import { AdminRoute } from '@/components/AdminRoute';
import { SignInPage } from '@/pages/SignInPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { UsersPage } from '@/pages/UsersPage';
import { AgenciesPage } from '@/pages/AgenciesPage';
import { AuditLogPage } from '@/pages/AuditLogPage';
import { GdprQueuePage } from '@/pages/GdprQueuePage';
import { PlansPage } from '@/pages/PlansPage';
import { CvTemplatesPage } from '@/pages/CvTemplatesPage';
import { PaymentsPage } from '@/pages/PaymentsPage';
import { AiCostPage } from '@/pages/AiCostPage';
import { JobSourcesPage } from '@/pages/JobSourcesPage';
import { SupportPage } from '@/pages/SupportPage';
import { SsoPage } from '@/pages/SsoPage';
import { TaxonomyPage } from '@/pages/TaxonomyPage';
import { FeatureFlagsPage } from '@/pages/FeatureFlagsPage';

/**
 * Admin SPA routing.
 *   /sign-in              public
 *   /*                    AdminRoute (auth + admin role + MFA verified)
 *                         ↳ AdminLayout (sidebar shell)
 *                            ↳ index → DashboardPage
 *                            ↳ /users, /agencies, ... management pages
 */
export const router = createBrowserRouter([
  { path: '/sign-in', element: <SignInPage /> },
  {
    path: '/',
    element: <AdminRoute />,
    children: [
      {
        element: <AdminLayout />,
        children: [
          { index: true, element: <DashboardPage /> },
          { path: 'users', element: <UsersPage /> },
          { path: 'agencies', element: <AgenciesPage /> },
          { path: 'payments', element: <PaymentsPage /> },
          { path: 'plans', element: <PlansPage /> },
          { path: 'cv-templates', element: <CvTemplatesPage /> },
          { path: 'job-sources', element: <JobSourcesPage /> },
          { path: 'taxonomy', element: <TaxonomyPage /> },
          { path: 'support', element: <SupportPage /> },
          { path: 'sso', element: <SsoPage /> },
          { path: 'feature-flags', element: <FeatureFlagsPage /> },
          { path: 'audit-log', element: <AuditLogPage /> },
          { path: 'gdpr', element: <GdprQueuePage /> },
          { path: 'ai-cost', element: <AiCostPage /> },
        ],
      },
    ],
  },
]);
